import { createAction } from 'redux-actions'
import { createNamespacedAction } from '../namespaces'

export const fetchRequest = createNamespacedAction('intelApi/FETCH_REQUEST')
export const fetchResponse = createNamespacedAction('intelApi/FETCH_RESPONSE')
export const mitreAttackActorsRequest = createAction('intelApi/MITRE_ATTACK_ACTORS_REQUEST')
export const mitreAttackMalwareRequest = createAction('intelApi/MITRE_ATTACK_MALWARE_REQUEST')
export const mitreAttackResponse = createAction('intelApi/MITRE_ATTACK_RESPONSE')
